"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubSituationPatrimonialeTrads = void 0;
exports.ESubSituationPatrimonialeTrads = {
    locataire: "Locataire",
    proprietaire: "Propriétaire",
    loge_titre_gratuit: "Logé(e) à titre gratuit",
};
